export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/caret-right-0445123c9621b07ceac58f2863e6f48d.svg";